
import React, { useState } from 'react';
import { Container, Row, Col, Form, Button, Alert } from 'react-bootstrap';
import { collection, addDoc } from 'firebase/firestore';
import { db } from '../firebase';
import Map from '../components/Map';

const ContactPage = () => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setSuccess(false);
    setError(null);

    try {
      await addDoc(collection(db, 'contactSubmissions'), {
        name,
        email,
        message,
        timestamp: new Date(),
      });
      setSuccess(true);
      setName('');
      setEmail('');
      setMessage('');
    } catch (err: any) {
      console.error("Error sending message:", err);
      setError(err.message || "Failed to send message.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="py-5 bg-light">
      <Container>
        <h2 className="text-center mb-4">Contact Us</h2>
        <p className="text-center">Feel free to reach out to us:</p>
        <p className="text-center"><strong>Phone:</strong> <a href="tel:+916354524007">+91 6354524007</a></p>
        <p className="text-center"><strong>Email:</strong> <a href="mailto:somanicvax@gmail.com">somanicvax@gmail.com</a></p>

        <div className="my-5">
          <h4 className="text-center mb-4">About Me</h4>
          <Row className="align-items-center">
            <Col md={8}>
              <p className="text-justify">
                Shivaksh Somani is a dedicated finance professional currently pursuing the CA Final qualification. With 9 years of comprehensive experience in the accounting and finance domain, Shivaksh currently serves as an Accounts and Finance Manager at a leading pharmaceutical export company. His expertise is further solidified by his prior experience working with Chartered Accountants, providing him with a robust understanding of diverse financial, legal, and tax landscapes. Shivaksh is committed to leveraging his extensive knowledge to empower individuals with accessible and practical insights into financial, legal, and tax matters.
              </p>
            </Col>
            <Col md={4} className="text-center">
              <img
                src="https://i.postimg.cc/m2Gn5XMb/IMG-20250702-WA0001.jpg"
                alt="Shivaksh Somani"
                className="img-fluid rounded-circle"
                style={{ maxWidth: '200px', height: 'auto' }}
              />
            </Col>
          </Row>
        </div>
        
        <div className="my-5">
          <h4 className="text-center mb-4">Our Location</h4>
          <Map />
        </div>

        <Form onSubmit={handleSubmit}>
          {loading && <Alert variant="info">Sending message...</Alert>}
          {success && <Alert variant="success">Message sent successfully!</Alert>}
          {error && <Alert variant="danger">{error}</Alert>}
          <Row>
            <Col md={6}>
              <Form.Group className="mb-3" controlId="formGroupName">
                <Form.Label>Name</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter your name"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  required
                />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group className="mb-3" controlId="formGroupEmail">
                <Form.Label>Email address</Form.Label>
                <Form.Control
                  type="email"
                  placeholder="Enter your email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </Form.Group>
            </Col>
          </Row>
          <Form.Group className="mb-3" controlId="formGroupMessage">
            <Form.Label>Message</Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              placeholder="Your message"
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              required
            />
          </Form.Group>
          <div className="text-center">
            <Button variant="primary" type="submit" disabled={loading}>
              Submit
            </Button>
          </div>
        </Form>
      </Container>
    </section>
  );
};

export default ContactPage;
